import React, { useEffect } from 'react';
import { createAsyncScriptNode } from '../../../utils/dom';
import { getUserlaneTags } from '../../../selectors/widgetsVisibility';
import { window, document } from '../../../env/browser';

const userlaneShoreAssistantCSS = `
#userlane-assistant-container {
  bottom: 90px !important;
  right: 20px !important;
  left: unset !important;
  width: 50px;
  height: 50px;
  min-height: 50px !important;

  #usln-p-assistant-bubble{
    right: 0;
  }

  #usln-p-assistant-avatar[aria-expanded="false"] {
    display: none;
  }
}`;

const userlaneWhiteLabelAssistantCSS = `
#userlane-assistant-container {
  bottom: 20px !important;
  right: unset !important;
  left: 20px !important;
  width: 50px;
  height: 50px;
  min-height: 50px !important;

  #usln-p-assistant-bubble{
    right: unset;
  }

  #usln-p-assistant-avatar[aria-expanded="false"] {
    display: block;
  }
}`;

export function UserlaneWidget({ appId, merchant, account, whiteLabel }) {
  useEffect(() => {
    const userlaneTags = getUserlaneTags(merchant, account);

    window.userlaneSettings = {
      app_id: appId,
      user: {
        id: account.id,
        tags: userlaneTags,
      },
      lang: account.locale,
      configs: {
        assistantPosition: whiteLabel === 'shore' ? 'right' : 'left',
      },
    };

    const scriptNode = createAsyncScriptNode({
      src: '//cdn.userlane.com/userlane.js',
      onload: () => {
        const { analytics, Userlane } = window;

        if (
          typeof analytics !== 'undefined' &&
          typeof analytics.track === 'function' &&
          typeof Userlane === 'function'
        ) {
          const trackUserlaneEvent = (when, what) => {
            Userlane(when, (userlaneId) => {
              analytics.track(what, {
                userlaneId,
              });
            });
          };
          trackUserlaneEvent('onStart', 'Userlane started');
          trackUserlaneEvent('onComplete', 'Userlane completed');
          trackUserlaneEvent('onExit', 'Userlane cancelled');

          if (whiteLabel === 'shore') {
            Userlane('hide');
          }
        }
      },
    });

    document.head.appendChild(scriptNode);

    return () => {
      document.head.removeChild(scriptNode);
    };
  }, [appId, merchant, account, whiteLabel]);

  return (
    <style
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html:
          whiteLabel === 'shore'
            ? userlaneShoreAssistantCSS
            : userlaneWhiteLabelAssistantCSS,
      }}
    />
  );
}
